<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    联系我们
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    <el-row>
                        <el-col :span="8" style="padding-right: 15px;">
                            <el-card :body-style="{ padding: '0px' }">
                                <div style="padding: 14px">
                                <span><b>舟山辰熙新材料有限公司</b></span>
                                <div class="bottom">
                                    电话：0086-173 4884 6658<br>
                                    邮箱：<br><a href="mailto:mengchao@chenxichem.com">mengchao@chenxichem.com</a><br><a href="mailto:yinliping@chenxichem.com">yinliping@chenxichem.com</a><br>
                                    地址：中国（浙江）自由贸易试验区舟山市定海区北蝉乡（综保区）<br>
                                    高新技术产业园区综保区公共仓储B区2号仓库办公楼401室<br>
                                </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="16" style="padding:0 15px;">
                            <el-card :body-style="{ padding: '0px' }">
                                <div style="padding: 14px">
                                <div class="bottom">
                                    <img src="../../../../assets/images/contactUs.png" class="mainPic"/>
                                </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </span>
            </el-col>
            <!-- <el-col :span="24"  style="text-align: left;padding:0px 60px 40px 60px;">
                <img src="../../../../assets/images/contactUs.png" class="mainPic"/>
            </el-col> -->
            
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "cn_contactus",
        components: {},
        data() {
            return {

            }
        }
    }
</script>